import React, { useState, useEffect } from "react";
import { request } from "../../../utils/request";
import dayjs from "dayjs";
import Select from "react-select";
import { getLink, toast } from "../../../utils/helpers";

const EstadosCuentaFormCXP = ({ toggle }) => {
    const [proveedores, setProveedores] = useState([]);
    const [selectedProveedores, setSelectedProveedores] = useState([]);

    useEffect(() => {
        let ignore = false;

        async function fetchProveedor() {
            if (!ignore) {
                const response = await request("contactos?tipo=proveedor");
                setProveedores(response.data);
            }
        }

        fetchProveedor();

        return () => {
            ignore = true;
        };
    }, []);

    function onChangeProveedor(values) {
        if (values) {
            setSelectedProveedores(values.map((i) => i.value));
        } else {
            setSelectedProveedores([]);
        }
    }

    const validate = (event) => {
        const form = new FormData(event.target);

        if (!form.get("contactos")) {
            event.preventDefault();
            toast("Debes seleccionar al menos un proveedor.", "error");
        }

        if (!form.get("tipo")) {
            event.preventDefault();
            toast("Debes seleccionar el tipo de reporte a generar.", "error");
        }
    };

    return (
        <form
            method='get'
            target='_blank'
            action={getLink(`/imprimir/estados-cuenta-cxp`)}
            onSubmit={validate}>
            <div className='popup__header'>Generar Estados de Cuentas</div>
            <div className='popup__body pt-3'>
                <div>
                    <div className="row">
                        <div className="col-12 text-center"><strong>Seleccione un reporte para generar</strong></div>
                        <div className="col-12 d-flex">
                            <div className="d-flex ml-auto mr-3">
                                <input type="radio" id="resumen" name="tipo" value="resumen" />
                                <label htmlFor="resumen" className="ml-2">Resumen</label>
                            </div>

                            <div className="d-flex ml-3 mr-auto">
                                <input type="radio" id="detalles" name="tipo" value="detalles" />
                                <label htmlFor="detalles" className="ml-2">Detalles</label>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label>Desde:</label>
                                <input
                                    type='date'
                                    name='desde'
                                    id='desde'
                                    className='form-control'
                                />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className='form-group'>
                                <label>Hasta:</label>
                                <input
                                    type='date'
                                    name='hasta'
                                    defaultValue={dayjs().endOf('month')
                                        .format("YYYY-MM-DD")}
                                    id='hasta'
                                    className='form-control'
                                />
                            </div>
                        </div>
                        <div className="col-12">
                            <div>
                                <div className='form-group' style={{ zIndex: 9999 }}>
                                    <label>Proveedores | <small>Puede seleccionar más de uno</small></label>
                                    <input
                                        type='hidden'
                                        name='contactos'
                                        value={selectedProveedores.join(",")}
                                    />
                                    <Select
                                        menuPosition={'fixed'}
                                        maxMenuHeight={250}
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        isLoading={proveedores.length === 0}
                                        isMulti
                                        loadingMessage={() => "Cargando Proveedores..."}
                                        onChange={onChangeProveedor}
                                        options={[{ value: "todos", label: "Todos" }, ...proveedores.map((proveedor) => ({
                                            value: proveedor.id,
                                            label: `${proveedor.identificacion || ''} - ${proveedor.nombre}`,
                                        }))]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='popup__footer d-flex'>
                <button
                    type='button'
                    onClick={toggle}
                    className='btn btn-plain ml-3 mr-auto'>
                    Atrás
                </button>
                <button type='submit' className='btn btn-primary ml-auto mr-3'>
                    Generar
                </button>
            </div>
        </form>
    );
}

export default EstadosCuentaFormCXP;
